/* eslint-disable carsys-custom/mui-do-not-reference-classnames-via-string */
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Stack from '@mui/material/Stack'
import { CircularProgress, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useTranslation } from 'react-i18next'

interface CustomerTabProps {
  customer: {
    CustEosId: string
    CustNo: string
    CustName: string
    Location: string
    Street: string
    ZipCode: string
    OuName: string
    ShipToLoc: string
  }
  allowProceed: (allow: boolean) => void
}

const useStyles = makeStyles(() => ({
  requiredLabel: {
    // eslint-disable-next-line carsys-custom/mui-do-not-reference-classnames-via-string
    '& .MuiInputLabel-asterisk': {
      color: 'red'
    }
  }
}))

function CustomerTab(props: CustomerTabProps): JSX.Element {
  const { t } = useTranslation()
  const customer = props.customer
  const classes = useStyles()
  if (!customer) {
    props.allowProceed(false)
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
        <CircularProgress size={20} />
      </Box>
    )
  }
  return (
    <Box style={{ margin: '0px', padding: '0px' }}>
      <Typography variant='h6' style={{ marginBottom: '22px', marginTop: '0px', fontSize: 20, fontWeight: 700 }}>
        {t('Customers.CustomerGeneralTab')}
      </Typography>
      <Stack
        component='form'
        sx={{
          width: '25ch'
        }}
        spacing={2}
        noValidate
        autoComplete='off'
      >
        <TextField
          id='outlined-read-only-input'
          label={t('Customers.CustomerNumber')}
          variant='outlined'
          size='small'
          aria-readonly
          defaultValue={customer.CustNo}
          sx={{
            width: 500,
            maxWidth: '100%',
            '& .MuiInputLabel-root': {
              paddingLeft: '3px',
              paddingRight: '3px',
              backgroundColor: '#FFFFFF'
            }
          }}
          InputProps={{
            readOnly: true
          }}
          InputLabelProps={{
            required: true,
            classes: {
              asterisk: classes.requiredLabel
            }
          }}
        />
        <TextField
          id='outlined-read-only-input'
          label={t('Customers.ShipToLocationID')}
          variant='outlined'
          size='small'
          aria-readonly
          defaultValue={customer.ShipToLoc}
          sx={{
            width: 500,
            maxWidth: '100%',
            '& .MuiInputLabel-root': {
              paddingLeft: '3px',
              paddingRight: '3px',
              backgroundColor: '#FFFFFF'
            }
          }}
          InputProps={{
            readOnly: true
          }}
          InputLabelProps={{
            required: true,
            classes: {
              asterisk: classes.requiredLabel
            }
          }}
        />
        <TextField
          id='outlined-read-only-input'
          label={t('Customers.CustomerName')}
          variant='outlined'
          size='small'
          defaultValue={customer.CustName}
          sx={{
            width: 500,
            maxWidth: '100%',
            '& .MuiInputLabel-root': {
              paddingLeft: '3px',
              paddingRight: '3px',
              backgroundColor: '#FFFFFF'
            }
          }}
          InputProps={{
            readOnly: true
          }}
          InputLabelProps={{
            required: true,
            classes: {
              asterisk: classes.requiredLabel
            }
          }}
        />
        <TextField
          id='outlined-read-only-input'
          label={t('Customers.Location')}
          variant='outlined'
          size='small'
          defaultValue={customer.Location}
          sx={{
            width: 500,
            maxWidth: '100%',
            '& .MuiInputLabel-root': {
              paddingLeft: '3px',
              paddingRight: '3px',
              backgroundColor: '#FFFFFF'
            }
          }}
          InputProps={{
            readOnly: true
          }}
          InputLabelProps={{
            required: true,
            classes: {
              asterisk: classes.requiredLabel
            }
          }}
        />
        <TextField
          id='outlined-read-only-input'
          label={t('Customers.Street')}
          variant='outlined'
          size='small'
          defaultValue={customer.Street}
          sx={{
            width: 500,
            maxWidth: '100%',
            '& .MuiInputLabel-root': {
              paddingLeft: '3px',
              paddingRight: '3px',
              backgroundColor: '#FFFFFF'
            }
          }}
          InputProps={{
            readOnly: true
          }}
          InputLabelProps={{
            required: true,
            classes: {
              asterisk: classes.requiredLabel
            }
          }}
        />
        <TextField
          id='outlined-read-only-input'
          label={t('Customers.ZipCode')}
          variant='outlined'
          size='small'
          defaultValue={customer.ZipCode}
          sx={{
            width: 500,
            maxWidth: '100%',
            '& .MuiInputLabel-root': {
              paddingLeft: '3px',
              paddingRight: '3px',
              backgroundColor: '#FFFFFF'
            }
          }}
          InputProps={{
            readOnly: true
          }}
          InputLabelProps={{
            required: true,
            classes: {
              asterisk: classes.requiredLabel
            }
          }}
        />
      </Stack>
    </Box>
  )
}

export default CustomerTab
